// =====================================================
// Accessibility helpers
// =====================================================

function makeAccessibleButton($el, label, onActivate) {
  if (!$el.length) return;

  if (!$el.is('button')) {
    $el.attr({
      tabindex: 0,
      role: 'button',
      'aria-label': label,
    });
  }

  $el.off('keydown.accessibleBtn').on('keydown.accessibleBtn', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      $(this).trigger('click');
    }
  });

  // Binds an optional click handler using a namespaced event to avoid duplicated listeners.
  if (onActivate) {
    $el.off('click.accessibleBtn').on('click.accessibleBtn', onActivate);
  }
}

// =====================================================
// Header / Navigation patches
// =====================================================

function modifyBtnNavToggle() {
  const navToggle = $('.mobile-nav-toggle');
  const closeToggle = $('.close-mobile-menu');

  if (!navToggle.length || navToggle.data('patched')) return;
  navToggle.data('patched', true);

  // Open menu → move focus inside when menu is actually open
  makeAccessibleButton(navToggle, 'Open menu', () => {
    requestAnimationFrame(() => {
      if ($('body').hasClass('mobile-menu-open') && closeToggle.length) {
        closeToggle.attr('tabindex', 0).focus();
      }
    });
  });

  // Close menu → return focus to toggle when menu is actually closed
  makeAccessibleButton(closeToggle, 'Close menu', () => {
    requestAnimationFrame(() => {
      if (!$('body').hasClass('mobile-menu-open')) {
        navToggle.focus();
      }
    });
  });
}

function modifySearchBox() {
  const searchInput = $('.header .inputFieldTextbox');
  const searchButton = $('.header .searchSubmitButton'); // <a> with onclick

  searchInput.attr('placeholder', 'Type here...');
  searchButton.attr('tabindex', '-1');
  searchButton.attr('aria-label', 'submit search');
}

// =====================================================
// Weather widget patch
// =====================================================

function modifyWeatherBug() {
  const widget = document.getElementById('weatherBugWidget');
  const desc = document.getElementById('weatherBugDescription');
  if (!widget || !desc) return;

  const observer = new MutationObserver(() => {
    const text = desc.textContent.trim();
    if (!text || widget.classList.contains('weatherBugSet')) return;

    widget.classList.add('weatherBugSet');

    const lastSpace = text.lastIndexOf(' ');
    if (lastSpace !== -1) {
      desc.textContent = text.substring(lastSpace + 1);
    }

    observer.disconnect();
  });

  observer.observe(desc, { childList: true, subtree: true });
}

// =====================================================
// Header height observer
// =====================================================

function observeHeaderHeight(selector = 'header', { offset = 0 } = {}) {
  const header = document.querySelector(selector);
  if (!header || !('ResizeObserver' in globalThis)) return { destroy() {} };

  let lastHeight = null;

  function apply() {
    const h = Math.round(header.getBoundingClientRect().height) + offset;

    if (h !== lastHeight) {
      lastHeight = h;
      document.documentElement.style.setProperty('--theme-header-height', `${h}px`);
    }
  }

  const ro = new ResizeObserver(apply);
  ro.observe(header);
  apply(); // initial set

  return { destroy: () => ro.disconnect() };
}

// =====================================================
// Feature Lineup patch
// =====================================================

function modifyFeatureLineup() {
  const lineups = $('.featureLineupContainer');
  if (!lineups.length) return;

  lineups.each((_, el) => {
    const $lineup = $(el);
    const containerWidth = $lineup.width();
    const buttonContainer = $lineup.find('.featureLineup-buttons.subContainer');
    const icons = buttonContainer.find('.featureLineup-social');
    const cta = buttonContainer.find('.featureLineup-buynow');

    if (!icons.children().length) {
      icons.remove();
      return;
    }

    const totalWidth = icons.outerWidth(true) + cta.outerWidth(true);

    if (totalWidth > containerWidth) {
      buttonContainer.addClass('column');
    }
  });
}

$(document).ready(() => {
  $('.generalmessage').prependTo('header');

  modifyBtnNavToggle();
  modifySearchBox();
  modifyFeatureLineup();
  modifyWeatherBug();
  makeAccessibleButton($('.close-mobile-menu'), 'Close menu');
  observeHeaderHeight('.header');
});
